import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
export function validateArguments(args, assertions) {
  var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(args)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (typeof args[key] !== assertions[key]) {
        throw new Error("Expected \"".concat(key, "\" to be of type \"").concat(assertions[key], "\", got \"").concat(args[key], "\" instead."));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}